<template>
    <div class="w_alert d_alert">
        <div class="w_alert_txt css_hack">{{ alertpop_text }}</div>
    </div>
</template>

<script>
export default {
    name: 'AlertPop',
    props:{
        alertpop_text: String
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

@keyframes a_fade_in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@-webkit-keyframes a_fade_in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@-moz-keyframes a_fade_in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@-ms-keyframes a_fade_in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@-o-keyframes a_fade_in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.w_alert {
  top: 66%;
  left: 50%;
  height: 1.8em;
  z-index: 9999;
  position: fixed;
  text-align: center;
}
.w_alert_txt {
  color: #ffffff;
  display: inline-block;
  margin-left: -100%;
  padding: 0.4em .8em;
  background: #527cac;
  box-shadow: rgba(0, 0, 0, 0.4) 0 0.08em 0.15em;
  border-radius: 0.2em;
  animation-name: a_fade_in;
  animation-duration: 0.35s;
  -webkit-animation-name: a_fade_in;
  -webkit-animation-duration: 0.35s;
}

</style>
